export function isAgentHubTravellerOrder(
  order: App.Order | App.AgentHubTravellerOrder | undefined,
): order is App.AgentHubTravellerOrder {
  return order?.responseType === 'agent_hub_traveller'
}

export function omitOrderFromState(
  state: Pick<App.OrdersState, 'orders' | 'agentHubTravellerOrders'>,
  orderId: string,
): Pick<App.OrdersState, 'orders' | 'agentHubTravellerOrders'> {
  const { [orderId]: _commercial, ...orders } = state.orders
  const { [orderId]: _restricted, ...agentHubTravellerOrders } = state.agentHubTravellerOrders
  return { orders, agentHubTravellerOrders }
}

export function isDeniedOrderAccessError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false
  }

  const status = (error as { status?: unknown, statusCode?: unknown }).status
    ?? (error as { statusCode?: unknown }).statusCode

  return status === 401 || status === 403 || status === 404
}
